import axios from "axios";
import { base_URL } from '../config/config';
const API_BASE_URL = `${base_URL}/api`;

export const getVendorEnquirySummary = async (page = 1, limit = 10, searchQuery = "", filter = "All") => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    let defaultCriteria = { criteria: [] };
    if(searchQuery) defaultCriteria.globalSearch = { type: "user", value: searchQuery };
    const response = await axios.get(`${API_BASE_URL}/vendor-enquiries-summary`, {
      params: { 
        page, 
        limit,
        ...(searchQuery && { searchQuery }),
        ...(defaultCriteria && { filter: JSON.stringify(defaultCriteria)}),
        type: filter

      },
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    return response.data;
  }
  catch(error) {
    console.error('Error fetching customers', error);
    throw error;
  }
}


export const getVenueEnquirySummary = async (page = 1, limit = 10, searchQuery = "", filter = "All") => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    let defaultCriteria = { criteria: [] };
    if(searchQuery) defaultCriteria.globalSearch = { type: "user", value: searchQuery };
    const response = await axios.get(`${API_BASE_URL}/venue-enquiries-summary`, {
      params: {
        page,
        limit,
        ...(searchQuery && { searchQuery }),
        ...(defaultCriteria && { filter: JSON.stringify(defaultCriteria)}),
        type: filter
      },
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    return response.data;
  }
  catch(error) {
    console.log('Error fetching customers', error);
    throw error;
  }
}

export const getCustomerEnquiries = async (customerId) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.get(`${API_BASE_URL}/enquiry/customer/${customerId}`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching customer enquiries', error);
    throw error;
  }
}
